import { NgModule } from '@angular/core';
import { MaintenanceComparisonFormComponent } from 'src/app/maintenance/components/maintenance-comparison-form/maintenance-comparison-form.component';
import { MaintenanceComparisonPageComponent } from 'src/app/maintenance/components/maintenance-comparison-page/maintenance-comparison-page.component';
import { MaintenanceLogsPageComponent } from 'src/app/maintenance/components/maintenance-logs-page/maintenance-logs-page.component';
import { SharedModule } from 'src/app/shared/shared.module';

@NgModule({
  imports: [SharedModule],
  declarations: [
    MaintenanceLogsPageComponent,
    MaintenanceComparisonPageComponent,
    MaintenanceComparisonFormComponent,
  ],
})
export class MaintenanceModule {}
